/** Same default as WebGalis PlatformFormsController.DefaultFormatsAllowed – one meaning for an empty setting. */
export const DEFAULT_FORMATS_ALLOWED: string[] = ['png', 'jpg', 'jpeg', 'pdf'];

/**
 * Form setting FormatsAllowed ("pdf,docx") as the upload allowlist. An empty setting means the default
 * list. The client list is the only type check today (the server checks only that a name has an
 * extension), so empty must never mean "any type".
 */
export function parseFormatsAllowed(value: string | null | undefined): string[] {
  const list = (value || '')
    .split(',')
    .map(x => x.trim().replace(/^\./, ''))
    .filter(x => x.length > 0);
  return list.length > 0 ? list : [...DEFAULT_FORMATS_ALLOWED];
}
